import { SlotBehavior as n } from "./slot-behavior.js";
class o {
  constructor(t) {
    this._element = t;
  }
  hasContent(t) {
    if (t === "content")
      return this._element.textContent != null && this._element.textContent.trim() !== "";
    const e = this._element[t];
    return e ? e.assignedNodes().length > 0 : !1;
  }
}
class l extends n {
  constructor(t, e) {
    super(), this._condition = t, this._styles = e;
  }
  removedCallback(t) {
    super.removedCallback(t), t.removeStyles(this._styles);
  }
  handleChange(t) {
    const e = new o(t);
    this._condition(e) ? t.$fastController.addStyles(this._styles) : t.$fastController.removeStyles(this._styles);
  }
}
function h(s, t) {
  return new l(s, t);
}
export {
  o as SlotsOf,
  h as slotStyleSheetBehavior
};
